(function() {
  let BundlePage = (function() {
    var settings = {
      mediaQueryMediumUp: 'screen and (min-width: 750px)',
      mediaQuerySmall: 'screen and (max-width: 749px)',
      filterBy: {},
      sortBy: false,
      activeTab: false,
      JSONcontent: false,
      blockNotification: false,
      sample: window.sessionStorage.getItem('bundle-sample') || false,
      lastActivePage: undefined,
      bundleState: {
        old: [],
        current: []
      },
      calledOnce: false
    };
  
    var selectors = {
      addPresetBundle: "[data-add-preset-bundle]",
      addToBundle: "[data-add-to-bundle]",
      backToProducts: "[data-bundle-back-to-products]",
      bundleContent: "#BundleBuilderContent",
      buttonContainer: "[data-button-container]",
      cartState: "#BundleBuilderCartState",
      filterByItem: "[data-filter-by-item]",
      filterList: "[data-filter-list]",
      filterSelection: "#FilterTags",
      filterSwatches: "[data-filter-swatches]",
      landing: "[data-bundle-landing]",
      mainContent: "#MainContent",
      meta: "[data-bundle-meta]",
      modalContent: "[data-modal-content]",
      notification: "#BundleBuilderNotification",
      presetBundlesTemplate: "#BundleBuilderPresetBundles",
      presetBundleItem: "[data-preset-bundle-item]",
      product: "[data-bundle-product]",
      productForm: "[data-product-form]",
      productContainer: "#ProductContainer",
      productImage: "[data-bundle-product-image]",
      productGridItem: "[data-product-grid-item]",
      productGridItems: "[data-product-grid-items]",
      productTitle: "[data-bundle-product-title]",
      productsContainer: "[data-bundle-products-container]",
      quickView: "#BundleBuilderQuickView",
      quickViewContent: "[data-modal-content]",
      quickViewTrigger: "[data-quick-view-trigger]",
      removeItem: "[data-bundle-item-remove]",
      showContent: "[data-bundle-show-content]",
      showPresets: "[data-bundle-show-presets]",
      showPresetsContainer: "[data-bundle-show-presets-container]",
      sortByItem: "[data-bundle-sort-by-item]",
      sortList: "[data-bundle-sort-list]",
      sortSelection: "#SortBy",
      stickyAddToCart: '[data-sticky-add-to-cart]',
      tabContainer: "[data-tab-container]",
      tabContent: "[data-tab-content]",
      tabTitle: "[data-tab-title]",
      viewSet: "[data-bundle-view-set]"
    };
    
    var data = {
      sorts: {},
      addedToBundle: 'added-to-bundle',
      bundleItemPrice: 'bundle-item-price',
      bundleItemTitle: 'bundle-item-title',
      presetBundleItems: 'preset-bundle-items',
      productHandle: 'product-handle',
      productTags: 'product-tags',
      target: 'target',
      value: 'value',
      filter: 'filter'
    };
    
    var classes = {
      active: 'active',
      btnSecondary: 'btn--secondary',
      bundleLoading: 'bundle--loading',
      bundleQuickViewTitle: 'bundle--quick-view__title',
      bundleQuickViewDescription: 'bundle--quick-view__description',
      bundleQuickViewNoteTitle: 'bundle--quick-view__note-title',
      bundleQuickViewNote: 'bundle--quick-view__note',
      hidden: 'hide',
      isFiltered: 'is-filtered',
      lazyload: 'lazyload',
      textCenter: 'text-center'
    }
  
    function checkLocalStorage() {
      var localData = window.localStorage.getItem('bundleData');
      var productHandle;
      
      if(!localData) return;
  
      localData = JSON.parse(localData);
      productHandle = localData.productHandle;
  
      $(selectors.product + '[data-' + data.productHandle + '="' + productHandle + '"]')
        .find(selectors.addToBundle)
        .click();
  
      $(selectors.viewSet).click();
  
      window.localStorage.removeItem('bundleData');
    };
  
    function checkURL() {
      const urlParams = new URLSearchParams(window.location.search);
      if (!urlParams.has('addbundle')) return;
      let productHandles = urlParams.get('addbundle').split(',');
  
      productHandles.forEach(
        function(productHandle) {
          $(selectors.product + '[data-' + data.productHandle + '="' + productHandle + '"]')
            .find(selectors.addToBundle)
            .click();
        }
      );
  
      $(selectors.viewSet).click();
        
    };
  
    function checkUpsell() {
      if (document.referrer.indexOf('/cart') == -1) return;
  
      if (!$('#CartJSON').html()) return;
  
      var cartJSON = JSON.parse(
        document.getElementById('CartJSON').innerHTML
      );
  
      var itemsRequired = 3;
      var counter = 0;
  
      cartJSON.items.forEach(function(item) {
        if (
          item.variant_title !== '10ml' ||
          counter >= itemsRequired
        ) return;
  
        var $addToBundle = $(selectors.product + '[data-' + data.productHandle + '="' + item.handle + '"]').find(selectors.addToBundle);
  
        if (!$addToBundle.length) return;
  
        $addToBundle.click();
        counter++;
  
      }.bind(this));
      
    };
    
    function initEvents(){
      $(selectors.filterByItem).on('click', onFilterClick);
      $(selectors.sortByItem).on('click', onSortClick);
      $(selectors.quickViewTrigger).on('click', onQuickViewClick);
      $(selectors.showPresets).on('click', onShowPresetsClick);
      $(selectors.addPresetBundle).on('click', onAddPresetBundleClick);
      $(window).off('scroll.bundleBuilder').on('scroll.bundleBuilder', initStickyAddToCart);
    };
    
    function initControls() {
      $(selectors.showContent).on('click', function() {
        $(selectors.meta).removeClass(classes.active);
        $(selectors.landing).removeClass(classes.active);
        $(selectors.productsContainer).addClass(classes.active);
        window.scrollTo(0,0);
        settings.lastActivePage = selectors.productsContainer;
      });
      
      $(selectors.viewSet).on('click', function() {
        $(selectors.landing).removeClass(classes.active);
        $(selectors.productsContainer).removeClass(classes.active);
        $(selectors.meta).addClass(classes.active);
        window.scrollTo(0,0);
        settings.lastActivePage = selectors.meta;
      });
      
      $(selectors.backToProducts).on('click', function() {
        $(selectors.meta).removeClass(classes.active);
        $(selectors.landing).removeClass(classes.active);
        $(selectors.productsContainer).addClass(classes.active);
        window.scrollTo(0,1);
        window.scrollTo(0,0);
        settings.lastActivePage = selectors.productsContainer;
      });
    };
    
    function onFilterClick(e) {
      var $target = $(this);
      var filter = $target.closest(selectors.filterList).data(data.filter);
      var value = $target.data(data.value);
      var isActive = $target.hasClass(classes.active);
      
      if (!settings.filterBy.hasOwnProperty(filter)) settings.filterBy[filter] = [];
      
      if (!isActive) {
        $target.addClass(classes.active);
        if (!settings.filterBy[filter].indexOf(value) > -1) 
          settings.filterBy[filter].push(value); //prevent duplicate values
        
      } else { 
        $target.removeClass(classes.active);
        settings.filterBy[filter] = settings.filterBy[filter].filter(function(item) { 
          return item !== value; 
        });
        
      }

      filterItems();
    }

    function filterItems(){
      let $productGridItem = $(selectors.productGridItem);

      $productGridItem
        .removeClass(classes.isFiltered)
        .show();
    
      for (let key in settings.filterBy) {
        if (!settings.filterBy[key].length) continue;
  
        var filter = `:not(.${classes.isFiltered})`;
  
        for (let index in settings.filterBy[key]) {
          filter += `:not([data-${data.productTags}*="[${settings.filterBy[key][index]}]"])`;
  
        }

        $productGridItem.each((index, pgi) => {
          if ($(pgi).is(filter)) {
            $(pgi)
              .addClass(classes.isFiltered)
              .hide();
          } 
        });
        
      }
  
    }
    
    function onSortClick(e) {
      var $target = $(this);
      var sortBy = $target.data(data.value);
      var sortCollection = settings.JSONcontent.general.products_collection
      settings.sortBy = sortBy;
      
      $target
        .addClass(classes.active)
        .siblings()
        .removeClass(classes.active);
      
      if (!sortCollection) return;
      
      if (data.sorts.hasOwnProperty(sortBy)) {
       sortProducts();
      } else {
        $(document.body)
        	.addClass(classes.bundleLoading);
        
        $.get( "/collections/" + sortCollection + "?view=sorted_json&sort_by=" + sortBy, function( response ) {
          var order = JSON.parse(response);
          
          data.sorts[sortBy] = order;
          
          sortProducts();
          
          $(document.body)
          	.removeClass(classes.bundleLoading);
        });
        
      }
    }

    function saveCurrentSortOrder() {
      if (!$(selectors.productGridItem).length) return;
      data.sorts['manual'] = [];
      $(selectors.productGridItem).each((index, pgi) => {
        let $pgi = $(pgi);
        data.sorts['manual'].push(
          $pgi.data(data.productHandle)
        );
      });
    }
    
    function sortProducts() {
      if(!settings.sortBy)
        return;
      
      var $productContainer = $(selectors.productContainer);
      var reorderedItems = $.map(data.sorts[settings.sortBy], function(el) {
        return $('[data-product-handle="' + el + '"]', $productContainer);
      });
      
      
      $productContainer.html(reorderedItems);
      
    }
    
    function manageState() {
      var $cartState = $(selectors.cartState);
      var cartStateJson;
      var ret = false
  	var oldState = [], currentState = [];
      
      if (!$cartState.html()) return;
      
      try {
        cartStateJson = JSON.parse(JSON.parse($cartState.html()));
        
      } catch(error) {
        console.log(error);
        console.error("Can't parse bundle cart state!");
        ret = true;
      }
      
      if (ret) return;
      
      settings.bundleState.current = cartStateJson;
      currentState = settings.bundleState.current.map(function(item) { return item; });
      oldState = settings.bundleState.old.map(function(item) { return item; });
      
      if (settings.bundleState.current.length > settings.bundleState.old.length) {
        oldState.forEach(function(itemOld) {
          var indexCurrentState = 0; 
          
          for(var i in currentState) {
            var itemCurrent = currentState[i];
            
            if (itemOld.variant.id === itemCurrent.variant.id) {
              indexCurrentState = i;
              break;
            }
          }
          
          currentState.splice(indexCurrentState, 1);
          
        });
        
        $(document.body)
          .trigger({
            type: 'bundlebuilder:custom:itemadded',
            item: currentState[0]
          });
  
        
      } else if (settings.bundleState.current.length < settings.bundleState.old.length) {
        currentState.forEach(function(itemCurrent) {
          var indexOldState = 0; 
          
          for(var i in oldState) {
            var itemOld = oldState[i];
            
            if (itemCurrent.variant.id === itemOld.variant.id) {
              indexOldState = i;
              break;
            }
          }
          
          currentState.splice(indexOldState, 1);
          
        });
        
        $(document.body)
          .trigger({
            type: 'bundlebuilder:custom:itemremoved',
            item: oldState[0]
          });	
        
      }
      
      settings.bundleState.old = settings.bundleState.current;
      
    };
    
    function onItemAdded(evt) {
      var variant = evt.item.variant;
  
      showNotification(variant.name.split(' - ')[0]);       
    };
    
    function refillData(){
      if (settings.filterBy) {
        for (var key in settings.filterBy) {
          if (!settings.filterBy[key].length) continue;
          
          settings.filterBy[key].forEach(function(item) {
            var $target = $(selectors.filterByItem + '[data-'  + data.value + '="' + item + '"]');
            $target
              .addClass(classes.active);
          });
        }
      }
      
      if (settings.sortBy) {
        $(selectors.sortByItem)
        	.filter('[data-' + data.value + '="' + settings.sortBy + '"]')
        	.trigger('click');
      }
      
      if (settings.activeTab) {
        $(selectors.tabTitle + '[data-target="' + settings.activeTab + '"]')
        	.trigger('click');
      }
      
      if (settings.sample) {
        $(selectors.product + '[data-' + data.productHandle + '="' + settings.sample + '"]')
        	.find(selectors.addToBundle)
        	.trigger('click');
        
        window.sessionStorage
        	.removeItem('bundle-sample');
  	      
        settings.sample = false;
      }
      
      if (
        typeof settings.lastActivePage !== 'undefined' &&
        $(settings.lastActivePage).length
      ) {
        $(selectors.landing)
          .add(selectors.viewSet)
          .add(selectors.backToProducts)
          .removeClass(classes.active);
  
        $(settings.lastActivePage)
        	.addClass(classes.active);
        
      }
        
    };
  
    function setupPresetBundles() {
      var $presetBundlesTemplate = $(selectors.presetBundlesTemplate);
      var $presetBundles = $($presetBundlesTemplate.html());
      
      if (!$(selectors.presetBundleItem, $presetBundles).length) return;
  
      $(selectors.productContainer)
        .after($presetBundles);
  
      $(selectors.showPresetsContainer)
        .removeClass(classes.hidden);
      
    };
  
    function onShowPresetsClick(e) {
      e.preventDefault();
      $(selectors.backToProducts).click();
  
      var $scrollElement = window.matchMedia(settings.mediaQuerySmall).matches ? $('html, body') : $(selectors.productsContainer);
  
      var scrollTo = $(selectors.productGridItems).height();
      
      $scrollElement.animate({
        scrollTop: scrollTo
      }, 250);
         
    };
  
    function onAddPresetBundleClick(e) {
      var $addPresetBundle = $(e.currentTarget);
      var $presetItem = $addPresetBundle.closest(selectors.presetBundleItem);
      var presetItemTitle = $presetItem.data(data.bundleItemTitle);    
      var productHandles = $addPresetBundle.data(data.presetBundleItems).split(',');
      var counter = $(selectors.removeItem).length;
      var delay = 200;
      var timeoutDelay = counter * delay + 2 * delay;
  
      settings.blockNotification = true;
      
      if (counter > 0) {
        var timer = setInterval(function() {
          var $removeItem = $(selectors.removeItem);
          if (counter <= 0 || !$removeItem.length) clearInterval(timer);
          $removeItem.eq(0).click();
          counter--;
        }, delay)
      }
      
      setTimeout(function() {
        productHandles.forEach(function(productHandle) {
          $(selectors.product + '[data-' + data.productHandle + '="' + productHandle + '"]')
            .find(selectors.addToBundle)
            .click();
        });
      }, timeoutDelay);
  
      setTimeout(function() {      
        settings.blockNotification = false;
        showNotification(presetItemTitle);
      }, timeoutDelay + delay * 3);
      
    }
    
    function init(){    
      if (!settings.calledOnce) {
        setTimeout(function(){
          checkLocalStorage();
          checkURL();
          checkUpsell();
          saveCurrentSortOrder();
        },3000);
        
        window.bbAfterAddToCart = function() {
          window.location = window.routes.cart_url;
        };

        let mqlSmall = window.matchMedia(settings.mediaQuerySmall);
        if (mqlSmall) $(document.body).on('bundlebuilder:custom:itemadded', onItemAdded);
        mqlSmall.addEventListener('change', () => {
          if (mqlSmall.matches) {
            $(document.body).on('bundlebuilder:custom:itemadded', onItemAdded);
          } else {
            $(document.body).off('bundlebuilder:custom:itemadded');
          }
        });
        
        settings.calledOnce = true;
      }
  
      setupPresetBundles();
      
      if (!data.sorts.hasOwnProperty('manual')) {
        data.sorts['manual'] = [];
        
        $(selectors.productContainer)
        	.children()
        	.each(function(){
          	data.sorts['manual']
              	.push($(this).data('product-handle'));
        	});
      }
      
      var $mainContent = $(selectors.mainContent);
      
      initEvents();
      initControls();
      refillData();
      manageState();
      
      if ($(selectors.bundleContent).html()) {
      
        if (!settings.JSONcontent) {
          settings.JSONcontent = JSON.parse($(selectors.bundleContent).html());
        }
  
        prepareImages();
      }
      
      loadImages();
    };
  
    function showNotification(title) {  
      if (
        !window.matchMedia(settings.mediaQuerySmall).matches ||
        settings.blockNotification
      ) return;
  
      var $notification = $(selectors.notification);
      var $notificationModalContent = $notification.find(selectors.modalContent);
      $notificationModalContent
        .text(title);
      
      var notificationModal = document.querySelector(selectors.notification);
      notificationModal.show();
      
      setTimeout(notificationModal.hide, 2500);
    
    };
  
    function initStickyAddToCart() {
      var $addToCart = $(selectors.productForm);
      var $stickyAddToCart = $(selectors.stickyAddToCart);
  
      if (!$addToCart.length ||
         !$stickyAddToCart.length) return;
         
      if(
        $addToCart.eq(0).offset().top  + 80 < window.pageYOffset && 
        !$stickyAddToCart.hasClass(classes.active)
      ) {
        $stickyAddToCart
          .prepareTransition()
          .addClass(classes.active);
        
      }
      
      if(
        $stickyAddToCart.hasClass(classes.active) &&
        $addToCart.eq(0).offset().top  - 100 > window.pageYOffset
      ) {
        $stickyAddToCart	
          .prepareTransition()
          .removeClass(classes.active);
  
      }
  
    };
  
    function prepareImages() {
      if (!settings.JSONcontent)
        return;
      
      var productSettingsData = settings.JSONcontent.settings;
      
      for(var key in productSettingsData) {
        $(selectors.product + '[data-product-handle="' + key + '"]')
          .each(function(){ 
  			var innerObject = productSettingsData[key];
          
              if(innerObject.hasOwnProperty('featured_image')) {
                if(!!innerObject['featured_image'] && innerObject['featured_image'] != "") {
                    var imageSrc = innerObject['featured_image'];
  
                    $(this)
                    .find(selectors.productImage)
                    .attr('data-src', imageSrc);
                }
              }	
          });	
      }
  
    };
    
    function loadImages() {
      $(selectors.productImage, selectors.product)
      	.addClass(classes.lazyload);
    };
    
    function onQuickViewClick(evt) {
      var $target = $(evt.currentTarget);
      var quickView = $target.data(data.target);
      var $quickView = $(quickView);
      var productHandle = $quickView.data(data.productHandle);
      var $buttonContainer = $quickView.find(selectors.buttonContainer);
      
      // slate.utils.modal(
      //   quickView, 
      //   function() {},
      //   function() {
      //     $(document.body).off('bundlebuilder:render.bbqv');
      //     $buttonContainer.off('click');
      //   }
      // );
      
      function copyAddButton() {
        var $addButton = $(selectors.product + '[data-' + data.productHandle + '="' + productHandle + '"]').find(selectors.addToBundle);
        $buttonContainer
        .html(
          $addButton
            .clone()
        );
  
      };
  
      $buttonContainer.on('click', 'button', function() {
        $(selectors.product + '[data-' + data.productHandle + '="' + productHandle + '"]')
          .find(selectors.addToBundle)
          .trigger('click');
  
      });
  
      copyAddButton();
  
  
      $(document.body).on('bundlebuilder:render.bbqv', copyAddButton);
      
    };
    
    return {
      init: init
    };
    
  })();

  if (typeof jQuery === "undefined") {    
    var script = document.createElement("script");
    script.src = "/cdn/shop/t/55/assets/jquery-v3.7.1.js?v=158417595810649192771709029606";
    script.type = "text/javascript";
    script.onload = function() {
      init();
    };

    document.head.appendChild(script);
  } else {
    init();
  }

  function init() {
    $(document).ready(function() {
      if(window.location.href.indexOf('/apps/bundles/') > -1) {
        $(document.body).on('bundlebuilder:render', function(e){
         BundlePage.init();
        }.bind(this));
      }
    });
  }
})();
  